<template>
  <div>
    <el-Form
      ref="deptForm"
      :model="deptForm"
      label-width="80px"
      :rules="deptRules"
      :inline="true"
      size="small"
    >
      <el-Form-item label="部门名字" prop="deptName">
        <el-input v-model="deptForm.deptName"></el-input>
      </el-Form-item>
      <el-Form-item label="管理员" prop="chargeUser">
        <el-select
          v-model="deptForm.chargeUser"
          filterable
          placeholder="请选择"
          style="width: 200px"
        >
          <el-option
            style="width: 200px"
            v-for="item in allSysUser"
            :key="item.userId"
            :label="item.realName"
            :value="item.userId"
          ></el-option>
        </el-select>
      </el-Form-item>
      <el-Form-item
        label="父级部门"
        prop="parentArr"
        v-if="deptForm.deptId != 1"
      >
        <el-cascader
          :props="prop"
          style="width: 200px"
          placeholder="请选择"
          v-model="deptForm.parentArr"
          :options="deptArrList"
        ></el-cascader>
      </el-Form-item>
      <el-Form-item label="部门邮箱" prop="email">
        <el-input v-model="deptForm.email"></el-input>
      </el-Form-item>

      <el-Form-item label="是否审批" prop="needAudit">
        <el-radio-group v-model="deptForm.needAudit">
          <el-radio :label="1">需要审批</el-radio>
          <el-radio :label="2">不需要审批</el-radio>
        </el-radio-group>
      </el-Form-item>
      <el-Form-item label="部门描述" prop="description">
        <el-input
          type="textarea"
          :rows="3"
          style="width: 490px"
          placeholder="请输入描述"
          v-model="deptForm.description"
        >
        </el-input>
      </el-Form-item>
      <div style="margin: 30px auto; width: 200px">
        <el-Form-item>
          <el-button type="primary" @click="onSubmit">立即提交</el-button>
          <el-button @click="closeWindow">取消</el-button>
        </el-Form-item>
      </div>
    </el-Form>
  </div>
</template>

<script>
import {
  requestAllDept,
  requestGetSysDeptTree,
  requestSaveSysDept,
  requestUserGet,
} from "../../../api";
import SelectUser from "../../SelectUser";
export default {
  name: "deptEdit",
  props: ["deptForm", "deptArrList"],
  data() {
    let isEmail = (rule, value, callback) => {
      if (!value) {
        callback();
      } else {
        const reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("邮箱格式如: 167816@163.com"));
        }
      }
    };
    return {
      deptRules: {
        deptName: [
          { required: true, message: "请输入部门名字", trigger: "change" },
          {
            min: 3,
            max: 50,
            message: "长度在 2 到 20 个字符",
            trigger: "change",
          },
        ],
        chargeUser: [
          { required: true, message: "请选择部门管理员", trigger: "change" },
        ],
        parentArr: [
          { required: true, message: "请输入父级部门", trigger: "change" },
        ],
        needAudit: [{ required: true, message: "", trigger: "change" }],
        email: [{ validator: isEmail, trigger: "change" }],
        description: [
          { required: true, message: "请输入部门描述", trigger: "change" },
          {
            min: 2,
            max: 100,
            message: "长度在 2 到 100 个字符",
            trigger: "change",
          },
        ],
      },
      deptList: [],
      userType: "",
      dialogVisible: false,
      allSysUser: [],
      prop: {
        value: "deptId",
        label: "deptName",
        checkStrictly: true,
        disabled: "show",
      },
    };
  },
  methods: {
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code == 200) {
        this.allSysUser = res.object;
      } else {
        this.$message.error("获取人员列表失败");
      }
    },
    onSubmit() {
      this.$refs["deptForm"].validate((valid) => {
        if (valid) {
          if (this.deptForm.parentArr) {
            this.deptForm.parentId = this.deptForm.parentArr[this.deptForm.parentArr.length - 1];
            this.deptForm.parentArr = this.deptForm.parentArr.join(",");
          }
          requestSaveSysDept(this.deptForm).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.$emit("closeWindow", 1);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    getAllSysDept() {
      requestAllDept().then((res) => {
        if (res.code == 200) {
          this.deptList = res.object;
        } else {
          this.$message.error("获取部门列表失败");
        }
      });
    },
    closeWindow() {
      this.$emit("closeWindow", 2);
    },
  },
  created() {
    this.loadSysUserData();
  },
};
</script>

<style scoped></style>
